import React from 'react';
import { Grid } from '@material-ui/core';
import { Label, TextField } from '../../formikFormInputs';
import FormField from '../../FindYourStrategy/FormikForms/FormField';
import { initFalse } from '../../../utils/constants';

export default ({values, errors, touched, handleChange, handleBlur}: any) => {
  const fields = [
    {
      className: '',
      component: TextField,
      label: <Label label={'Your email'} required={!initFalse} />,
      name: 'email',
      rowSize: 12,
      type: 'email'
    },
    {
      className: '',
      component: TextField,
      label: <Label label={'Enter password'} required={!initFalse} />,
      name: 'password',
      rowSize: 12,
      type: 'password'
    }
  ]

  return (
    <Grid container spacing={3}>
      {
        fields.map((field, index) => (
          <FormField
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            key={index}
            touched={touched}
            values={values}
            {...field}
          />
        ))
      }
    </Grid>
  )
}
